import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

interface PropsType {
  id: string;
  content: string;
  place?: "bottom" | "top" | "left" | "right";
  style?: React.CSSProperties;
};

export default function HelpText({ id, content, place, style }: PropsType) {
  return (
    <ReactTooltip
      id={id}
      place={place || "bottom"}
      content={content}
      style={style}
      className="z-3 fs-12 fw-semibold"
    />
  );
};